import Css from "./style.module.scss";

import demoBackground from "assets/demoBackgroundA.jpg";

import * as Icons from "@phosphor-icons/react";
import { getActiveOrganization } from "selectors/organizations";
import { getTextsData } from "selectors/texts";
import { getUserData, getUserRestrictions } from "selectors/user";
import { useDispatch, useSelector } from "react-redux";
import AddNewBusiness from "nlib/common/AddNewBusiness";
import AskDiscoverySourceModal from "./lib/AskDiscoverySourceModal";
import Async from "utils/Async";
import PostSignUp from "nlib/common/PostSignUp";
import React, { useEffect, useMemo } from "react";
import UserActions from "actions/UserActions";
import UserRoles from "const/UserRoles";
import useShowModal from "hooks/useShowModal";

const ASK_DISCOVERY_SOURCE_DELAY = 2000;

const NoBusinessData = () => {
  const dispatch = useDispatch();

  const { uiTexts, errors } = useSelector(getTextsData);

  const activeOrganization = useSelector(getActiveOrganization);

  const userData = useSelector(getUserData);

  const demoBackgroundStyle = useMemo(() => {
    return { backgroundImage: `linear-gradient(rgba(0, 49, 102, 0.3), rgba(0, 49, 102, 0.3)), url(${demoBackground})` };
  }, []);

  const businessUser = UserRoles.checkIsBusiness(userData.role);

  const userRestrictions = useSelector(getUserRestrictions);

  const { currency, countryCode } = activeOrganization || {};

  const billingIssue = activeOrganization.billingId && !activeOrganization.subscriptionId;

  const [
    discoverySourceModalShown,
    showDiscoverySourceModal,
    onDiscoverySourceModalClose
  ] = useShowModal();

  useEffect(() => {
    return Async.setTimeout(() => {
      if (!billingIssue && !userData.discoverySourceAsked) {
        showDiscoverySourceModal().then((result) => {
          dispatch(UserActions.editUser({
            discoverySource: result || "",
            backgroundUpdate: true,
            silentUpdate: true
          }));
        });
      }
    }, ASK_DISCOVERY_SOURCE_DELAY);
  }, [billingIssue, showDiscoverySourceModal, dispatch, userData.discoverySourceAsked]);
  if (!businessUser && ((activeOrganization.billingId && !activeOrganization.subscriptionId) || userData.holdUser)) {
    return (
      <div className={Css.noBusinessData} style={demoBackgroundStyle}>
        <PostSignUp />
        {discoverySourceModalShown && (
          <AskDiscoverySourceModal onClose={onDiscoverySourceModalClose} />
        )}
      </div>
    );
  }
  if (businessUser || !currency || !countryCode || userRestrictions.businessesCreate) {
    const [accessDeniedErrorA, accessDeniedErrorB] = errors.accessDenied;

    return (
      <div className={Css.noBusinessData} style={demoBackgroundStyle}>
        <div className={Css.errorContainer}>
          <Icons.Warning weight="thin" className={Css.icon} />
          <div className={Css.title}>{accessDeniedErrorA}</div>
          <div className={Css.description}>{accessDeniedErrorB}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={Css.noBusinessData} style={demoBackgroundStyle}>
      <div className={Css.addNewBusiness}>
        <div className={Css.card}>
          <div className={Css.title}>{uiTexts.connectNewBusiness}</div>
          <AddNewBusiness />
          {discoverySourceModalShown && (
            <AskDiscoverySourceModal onClose={onDiscoverySourceModalClose} />
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(NoBusinessData);
